import React from 'react';

import { useTheme } from '@mui/material/styles';

import FavoriteIcon from '@mui/icons-material/Favorite';

import BaseActionButton from '../BaseActionButton';
import { IBaseActionButtonProps } from '../interfaces';

const RemoveReactionActionButton = (props: IBaseActionButtonProps) => {
  const theme = useTheme();

  return (
    <BaseActionButton
      {...props}
      styles={{ ...props.styles, color: theme.palette.primary.main }}>
      <FavoriteIcon />
    </BaseActionButton>
  );
};

export default RemoveReactionActionButton;
